import {
  SET_CENTRO_CUSTO_ACTION,
  SET_EMPRESA_ACTION,
  SET_FORNECEDOR_ACTION,
  SET_GRUPO_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_RESPONSAVEL_ACTION,
  SET_SOLICITANTE_ACTION,
  SET_TIPO_PRODUTO_ACTION,
} from './actions.type';
import {
  SET_CENTRO_CUSTO,
  SET_EMPRESA,
  SET_FORNECEDOR,
  SET_GRUPO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_SOLICITANTE,
  SET_TIPO_PRODUTO,
} from './mutations.type';

export default {
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_CENTRO_CUSTO_ACTION](context, centroCusto) {
    context.commit(SET_CENTRO_CUSTO, centroCusto);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_RESPONSAVEL_ACTION](context, responsavel) {
    context.commit(SET_RESPONSAVEL, responsavel);
  },
  [SET_GRUPO_ACTION](context, grupo) {
    context.commit(SET_GRUPO, grupo);
  },
  [SET_FORNECEDOR_ACTION](context, fornecedor) {
    context.commit(SET_FORNECEDOR, fornecedor);
  },
  [SET_SOLICITANTE_ACTION](context, solicitante) {
    context.commit(SET_SOLICITANTE, solicitante);
  },
  [SET_TIPO_PRODUTO_ACTION](context, tipoProduto) {
    context.commit(SET_TIPO_PRODUTO, tipoProduto);
  },
};
